import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/
import urlTemplate from 'url-template';
import { EngagekitChoreographerPlugin } from '@atlassian/ipm-choreographer';
import { NO_CONTENT } from '../../controllers/coordination/utils/status-codes';
import { errorIfNotOk, pullResponseTextIfNotOk, stargateFetch } from '../fetch-utils';
export var TARGETING_SCHEMA_VERSION = '2';
var inProductMessagesUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
export function getMessages(_x, _x2, _x3, _x4) {
  return _getMessages.apply(this, arguments);
}
function _getMessages() {
  _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cloudId, stargateUrl, product, locale) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", stargateFetch("".concat(stargateUrl).concat(inProductMessagesUrlTemplate.expand({
            cloudId: cloudId,
            product: product,
            schema: TARGETING_SCHEMA_VERSION,
            locale: locale
          }))).then(errorIfNotOk).then(function (r) {
            return r.json().then(function (messages) {
              return {
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
              };
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMessages.apply(this, arguments);
}
function handleStartStopMessageResponse(response) {
  return response.status === NO_CONTENT;
}
var startMessageUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
var startMessageWithVariationIdUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
var stopMessageUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
//  Adding these types because we are not able to import them properly from @atlassiansox/analytics-web-client
export var envType = /*#__PURE__*/function (envType) {
  envType["LOCAL"] = "local";
  envType["DEV"] = "dev";
  envType["STAGING"] = "staging";
  envType["PROD"] = "prod";
  return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
var choreographerPlugin;
export function startMessage(_x5, _x6) {
  return _startMessage.apply(this, arguments);
}
function _startMessage() {
  _startMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(startMessageConfig, options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(options !== null && options !== void 0 && options.enableChoreographer)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", startMessageWithChoreographer(startMessageConfig, options));
        case 2:
          return _context2.abrupt("return", startMessageWithCoordination(startMessageConfig));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _startMessage.apply(this, arguments);
}
export function stopMessage(_x7, _x8) {
  return _stopMessage.apply(this, arguments);
}
function _stopMessage() {
  _stopMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(stopMessageConfig, options) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(options !== null && options !== void 0 && options.enableChoreographer)) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", stopMessageWithChoreographer(stopMessageConfig, options));
        case 2:
          return _context3.abrupt("return", stopMessageWithCoordination(stopMessageConfig));
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _stopMessage.apply(this, arguments);
}
function startMessageWithChoreographer(_x9, _x10) {
  return _startMessageWithChoreographer.apply(this, arguments);
}
function _startMessageWithChoreographer() {
  _startMessageWithChoreographer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(startMessageConfig, options) {
    var _options$envType;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!choreographerPlugin) {
            choreographerPlugin = new EngagekitChoreographerPlugin((_options$envType = options.envType) !== null && _options$envType !== void 0 ? _options$envType : envType.LOCAL);
          }
          return _context4.abrupt("return", choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, function () {
            return startMessageWithCoordination(startMessageConfig, true);
          }, options.additionalData));
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _startMessageWithChoreographer.apply(this, arguments);
}
function stopMessageWithChoreographer(_x11, _x12) {
  return _stopMessageWithChoreographer.apply(this, arguments);
}
function _stopMessageWithChoreographer() {
  _stopMessageWithChoreographer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(stopMessageConfig, options) {
    var _options$envType2;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!choreographerPlugin) {
            choreographerPlugin = new EngagekitChoreographerPlugin((_options$envType2 = options.envType) !== null && _options$envType2 !== void 0 ? _options$envType2 : envType.LOCAL);
          }
          return _context5.abrupt("return", choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, function () {
            return stopMessageWithCoordination(stopMessageConfig, true);
          }, options.additionalData));
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _stopMessageWithChoreographer.apply(this, arguments);
}
function startMessageWithCoordination(_x13) {
  return _startMessageWithCoordination.apply(this, arguments);
}
function _startMessageWithCoordination() {
  _startMessageWithCoordination = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(startMessageConfig) {
    var choreographerEnabled,
      requestBody,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          choreographerEnabled = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
          requestBody = {
            cloudId: startMessageConfig.cloudId,
            orgId: startMessageConfig.orgId,
            workspaceId: startMessageConfig.workspaceId,
            choreographerEnabled: choreographerEnabled
          };
          return _context6.abrupt("return", stargateFetch(startMessageConfig.variationId ? "".concat(startMessageConfig.stargateUrl).concat(startMessageWithVariationIdUrlTemplate.expand({
            messageId: startMessageConfig.messageId,
            variationId: startMessageConfig.variationId
          })) : "".concat(startMessageConfig.stargateUrl).concat(startMessageUrlTemplate.expand({
            messageId: startMessageConfig.messageId
          })), {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(handleStartStopMessageResponse));
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _startMessageWithCoordination.apply(this, arguments);
}
function stopMessageWithCoordination(_x14) {
  return _stopMessageWithCoordination.apply(this, arguments);
}
function _stopMessageWithCoordination() {
  _stopMessageWithCoordination = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(stopMessageConfig) {
    var choreographerEnabled,
      requestBody,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          choreographerEnabled = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
          requestBody = {
            cloudId: stopMessageConfig.cloudId,
            orgId: stopMessageConfig.orgId,
            workspaceId: stopMessageConfig.workspaceId,
            choreographerEnabled: choreographerEnabled
          };
          return _context7.abrupt("return", stargateFetch("".concat(stopMessageConfig.stargateUrl).concat(stopMessageUrlTemplate.expand({
            messageId: stopMessageConfig.messageId
          })), {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(handleStartStopMessageResponse));
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _stopMessageWithCoordination.apply(this, arguments);
}
var userResponseUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
export function sendUserResponse(_x15, _x16, _x17, _x18) {
  return _sendUserResponse.apply(this, arguments);
}
function _sendUserResponse() {
  _sendUserResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(cloudId, stargateUrl, messageId, payload) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", stargateFetch("".concat(stargateUrl).concat(userResponseUrlTemplate.expand({
            cloudId: cloudId,
            messageId: messageId
          })), {
            method: 'post',
            body: JSON.stringify(payload),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(function () {
            return Promise.resolve();
          }));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _sendUserResponse.apply(this, arguments);
}
var markSeenAndFatigueUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
export function markAsSeenAndFatigued(_x19) {
  return _markAsSeenAndFatigued.apply(this, arguments);
}
function _markAsSeenAndFatigued() {
  _markAsSeenAndFatigued = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(seenMessageConfig) {
    var requestBody;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          requestBody = {
            cloudId: seenMessageConfig.cloudId,
            orgId: seenMessageConfig.orgId,
            workspaceId: seenMessageConfig.workspaceId
          };
          return _context9.abrupt("return", stargateFetch("".concat(seenMessageConfig.stargateUrl).concat(markSeenAndFatigueUrlTemplate.expand({
            messageId: seenMessageConfig.messageId
          })), {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(function () {
            return Promise.resolve();
          }));
        case 2:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _markAsSeenAndFatigued.apply(this, arguments);
}